import styled from 'styled-components';

export const InvoiceWrapper = styled.div(() => ({
  textAlign: 'center',
  width: '100%',
  alignSelf: 'center',
}));
